export default {"src":"/_next/static/media/gch.68129cf4.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};